import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { useContext } from "react";
import { ProjectContext } from "../contexts/ProjectContext";

function useUpdate() {

  const {element, setBackendFormErrors} = useContext(ProjectContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update('projects', element.id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors)
      })
  }
}

export default useUpdate;